<!--
 * @Descripttion: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-07-28 16:01:02
 * @LastEditTime: 2020-08-17 17:53:46
--> 
<template>
  <md-scroll-view
    :scrolling-x="false"
    :auto-reflow="true"
    class="physical-search-scroll-view-wrapper"
    ref="physicalScrollView"
    @end-reached="onEndReached"
    :end-reached-threshold="200"
    :immediate-check-end-reaching="false"
    v-loading="isLoading">
    <div class="total-box">
      <span class="primary search-text">「{{searchText}}」</span>共找到<span class="primary">{{total}}</span>个产品:
    </div>
    <ListItem :list="listData" />
  </md-scroll-view>
</template>

<script>
import { getYouZanKeGoods } from "@/api/distribution";
import ListItem from '@/pages/physical/components/listItem'

export default {
  data() {
    return {
      total: 0,
      listParams: {
        pageNum: 1,
        pageSize: 10,
        categoryId: '',
        titleLike: '',
        orderBy: '',
        orderFlag: '',
      },
      isLoading: false,
      listData: [],
      canScroll: false
    }
  },
  props: {
    searchText: {
      type: String,
      default: ''
    }
  },
  components: {
    ListItem
  },
  methods: {
    //获取实物分销搜索结果
    load() {
      this.isLoading = true;
      let params = {...this.listParams, titleLike: this.searchText}
      getYouZanKeGoods(params).then(res=>{
        this.isLoading = false;
        if(res.success) {
          this.total = res.data.count;

          if (!this.listData.length || (this.listData.length && (this.listData[0].alias !== res.data.goodList[0].alias))) {
            this.listData = [...this.listData, ...res.data.goodList || []];
          }            

          if (this.listData.length < res.data.count) {
            // 还能滚动
            this.canScroll = true;
          } else {
            // 滚动到底了
            this.canScroll = false;
          }
        }
        this.$refs.physicalScrollView.finishLoadMore();
      })
    },
    onEndReached() {
      if (this.canScroll) {
        console.log('加载更多')
        this.listParams.pageNum++;
        this.load();
      }
    }
  },
  created() {
    this.load()
  }
}
</script>

<style lang="scss">
  .physical-search-scroll-view-wrapper{
    height: calc(100vh - 124px);

    .total-box{
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #707073;
      padding: 0 32px;

      .primary{
        color: $primary-color;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;      
      }
      .search-text {
        max-width: 300px;
      }
    }
  }
</style>